import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c41339c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "UTC", -1))
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["data-hour"]
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  hidden: "",
  disabled: "",
  selected: ""
}, "Add a new location", -1))
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (i) => {
        return _createElementVNode("div", { key: i }, _toDisplayString(i), 1)
      }), 64)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedLocations, (location, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: location.id
        }, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": ($event: any) => ((_ctx.selectedLocationIds[i]) = $event)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: location.id,
                  value: location.id
                }, _toDisplayString(location.city) + ", " + _toDisplayString(location.country), 9, _hoisted_4))
              }), 128))
            ], 8, _hoisted_3), [
              [_vModelSelect, _ctx.selectedLocationIds[i]]
            ])
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (i) => {
            return _createElementVNode("div", {
              key: i,
              "data-hour": _ctx.getHour(i, location.hoursOffset)
            }, _toDisplayString(_ctx.getHour(i, location.hoursOffset)), 9, _hoisted_5)
          }), 64))
        ], 64))
      }), 128)),
      _createElementVNode("select", {
        value: _ctx.newLocationVModel,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setNewLocationVModel($event.target.value)))
      }, [
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
          return (_openBlock(), _createElementBlock("option", {
            key: location.id,
            value: location.id
          }, _toDisplayString(location.city) + ", " + _toDisplayString(location.country), 9, _hoisted_8))
        }), 128))
      ], 40, _hoisted_6)
    ])
  ]))
}